<template>
    <div class="mt-0 mb-2">
        <div v-if="row.attachmentURL" class="audio-attachment">
            <audio
                class="mb-3"
                controls
                v-if="isAudio(row.attachmentURL)"
                :src="row.attachmentURL"
            ></audio>
        </div>
        <div
            style="max-width: 1000px; white-space: pre-line !important; margin-top: -20px"
        >
            {{ row.text }}
        </div>
    </div>
</template>
<script>
import moment from "moment";
import { toTitleCase, except, formatCurrency } from "../../utils/helpers.js";

export default {
    props: {
        row: Object,
        columns: Array,
        reloadGrid: Function,
    },
    data() {
        return {};
    },
    async created() {},
    computed: {},
    methods: {
        isAudio(url) {
            return url.match(/.(mp3|wav|wma)$/i);
        },
    },
};
</script>
<style></style>
